import React from 'react';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectionBar from 'components/UI/SelectionBar/SelectionBar';
import SearchBar from 'components/UI/V3/SearchBar/SearchBar';
import Spinner from 'components/UI/V3/Spinner/Spinner';
import styles from './ClientMemberships.module.scss';

interface ClientMembershipsFiltersProps {
    selectedFilter: string;
    selectedFilterCount: number | null;
    searchText: string;
    onSelectFilter: (value: string) => void;
    onChangeSearchText: (value: string) => void;
}

export const ClientMembershipsFilters: React.FC<ClientMembershipsFiltersProps> = ({
    selectedFilter,
    selectedFilterCount,
    searchText,
    onSelectFilter,
    onChangeSearchText
}) => {
    const getOptionName = (id: string, label: React.ReactNode) => {
        if (selectedFilter !== id) return label;

        return (
            <span className={styles.filterCountLabel}>
                {label}
                {selectedFilterCount === null ? (
                    <>
                        <span>(</span>
                        <span className={styles.filterCountSpinner}>
                            <Spinner
                                size={14}
                                color="#EAB464"
                            />
                        </span>
                        <span>)</span>
                    </>
                ) : (
                    <span>({selectedFilterCount})</span>
                )}
            </span>
        );
    };

    return (
        <>
            <SelectionBar
                options={[
                    {
                        id: 'past_due',
                        name: getOptionName(
                            'past_due',
                            <>
                                <FontAwesomeIcon
                                    icon={faExclamationCircle}
                                    className={styles.pastDueIcon}
                                />{' '}
                                Past Due
                            </>
                        ),
                        selectedBackgroundColor: '#E36E74'
                    },
                    { id: 'active', name: getOptionName('active', 'Active') },
                    { id: 'pending', name: getOptionName('pending', 'Pending') },
                    { id: 'paused', name: getOptionName('paused', 'Paused') },
                    { id: 'canceled', name: getOptionName('canceled', 'Canceled') },
                    { id: 'all', name: getOptionName('all', 'All') }
                ]}
                selectedId={selectedFilter}
                onSelect={onSelectFilter}
                className={styles.selectionBar}
            />

            <SearchBar
                searchText={searchText}
                onChangeSearchText={onChangeSearchText}
                placeholder="Search by Pet"
                className={styles.searchBarContainer}
            />
        </>
    );
};

export default ClientMembershipsFilters;
